export default {
  id: 'transactions',
  title: 'Transactions (admin)',
  note: 'The operator transaction list: filters, table, pagination, the detail modal and the create-transaction form.',
  texts: {
    'transactions.crumb': 'Transactions',
    'transactions.title': 'Transactions',
    'transactions.sub.demo': 'Sample data · {agreements} agreements registered · connect data to see live tx',
    'transactions.sub.live': '{transactions} transactions · {agreements} agreements',

    'transactions.action.exportCsv': 'Export CSV',
    'transactions.action.generateReports': 'Generate G6 reports',
    'transactions.action.newTransaction': '+ New transaction',

    'transactions.confirm.generateReports':
      'Generate G6 statement reports from current transactions? Idempotent — re-runs skip existing reports.',

    'transactions.error.load': 'Failed to load transactions',
    'transactions.toast.csvExported': 'CSV exported',
    'transactions.toast.csvExportFailed': 'CSV export failed',
    'transactions.toast.reportsGenerated': '{created} new G6 reports created · {skipped} skipped (already exist)',
    'transactions.toast.reportGenerationFailed': 'Report generation failed',
    'transactions.toast.detailFailed': 'Failed to load transaction detail',
    'transactions.toast.created': 'Transaction created',
    'transactions.toast.createFailed': 'Create failed',

    'transactions.filter.searchPlaceholder': 'Search TX ID, RICS, agreement, train…',
    'transactions.filter.dateLabel': 'Date:',
    'transactions.filter.date.all': 'all',
    'transactions.filter.date.last7Days': 'last 7 days',
    'transactions.filter.date.last30Days': 'last 30 days',
    'transactions.filter.date.thisMonth': 'this month',
    'transactions.filter.date.lastMonth': 'last month',
    'transactions.filter.agreementLabel': 'Agreement:',
    'transactions.filter.agreementAll': 'all ({count})',
    'transactions.filter.selected': '{count} selected · ',
    'transactions.filter.matching': '{count} matching',
    'transactions.density.title': 'Density: {density}',

    'transactions.tab.all': 'All',
    'transactions.tab.reconciled': 'Reconciled',
    'transactions.tab.pending': 'Pending',
    'transactions.tab.disputed': 'Disputed',

    'transactions.col.select': 'Select',
    'transactions.col.id': 'Transaction ID',
    'transactions.col.date': 'Date',
    'transactions.col.selling': 'Selling RICS',
    'transactions.col.buying': 'Buying RICS',
    'transactions.col.agreement': 'Agreement',
    'transactions.col.train': 'Train · Route',
    'transactions.col.amount': 'Amount',
    'transactions.col.split': 'Split',
    'transactions.col.net': 'Net to selling',
    'transactions.col.status': 'Status',
    'transactions.col.actions': 'Actions',

    'transactions.table.loading': 'Loading…',
    'transactions.table.empty': 'No transactions match the current filter.',
    'transactions.row.openDetails': 'Open transaction details',

    'transactions.foot.showing.a': 'Showing',
    'transactions.foot.showing.b': 'of',
    'transactions.foot.pageSize': 'Page size:',
    'transactions.foot.pageOf': 'Page {page} of {total}',

    'transactions.detail.title': 'Transaction {id}',
    'transactions.detail.id': 'ID',
    'transactions.detail.transactionId': 'Transaction ID',
    'transactions.detail.type': 'Type',
    'transactions.detail.agreement': 'Agreement',
    'transactions.detail.seller': 'Seller',
    'transactions.detail.supplier': 'Supplier',
    'transactions.detail.sellerOrderId': 'Seller Order ID',
    'transactions.detail.supplierOrderId': 'Supplier Order ID',
    'transactions.detail.transactionTime': 'Transaction time',
    'transactions.detail.price': 'Price',
    'transactions.detail.priceType': 'Price type',
    'transactions.detail.service': 'Service',
    'transactions.detail.idempotencyKey': 'Idempotency key',
    'transactions.detail.createdAt': 'Created at',

    'transactions.create.title': 'New transaction',
    'transactions.create.type': 'Type',
    'transactions.create.agreement': 'Agreement',
    'transactions.create.agreementPlaceholder': '— select agreement —',
    'transactions.create.seller': 'Seller',
    'transactions.create.sellerPlaceholder': '— seller —',
    'transactions.create.supplier': 'Supplier',
    'transactions.create.supplierPlaceholder': '— supplier —',
    'transactions.create.price': 'Price (in cents)',
    'transactions.create.currency': 'Currency',
    'transactions.create.priceType': 'Price type',
    'transactions.create.service': 'Service (train + route)',
    'transactions.create.servicePlaceholder': 'e.g. EC 41 WAW-ZRH',
    'transactions.create.cancel': 'Cancel',
    'transactions.create.submit': 'Create transaction',
    'transactions.create.submitBusy': 'Creating…',
  },
}
